"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Logo", {
  enumerable: true,
  get: function () {
    return _Logo.default;
  }
});
Object.defineProperty(exports, "LogoIH", {
  enumerable: true,
  get: function () {
    return _LogoIH.default;
  }
});
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function () {
    return _styles.ThemeProvider;
  }
});
exports.theme = exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _Logo = _interopRequireDefault(require("./components/Logo"));
var _LogoIH = _interopRequireDefault(require("./components/LogoIH"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const assets = require('./theme/assets');
const palette = require('./theme/palette');
const breakpoints = require('./theme/breakpoints');
const mixins = require('./theme/mixins');
const shadows = require('./theme/shadows');
const transitions = require('./theme/transitions');
const zIndex = require('./theme/z-index');
const spacing = require('./theme/spacing');
const typography = require('./theme/typography');

// styled-system helpers:
const space = require('./theme/space');
const theme = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _styles.createTheme)(_objectSpread({
    status: {
      danger: 'orange'
    },
    assets,
    palette,
    breakpoints,
    mixins,
    spacing,
    space,
    shadows,
    direction: 'ltr',
    overrides: {},
    transitions,
    typography,
    zIndex,
    shape: {
      borderRadius: 4
    },
    props: {},
    themeName: 'Invitation Homes Theme'
  }, options));
};
exports.theme = theme;
var _default = exports.default = theme;
//# sourceMappingURL=main.js.map